import { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getDoc, doc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../firebase.config";
import Spinner from "../components/Spinner";
import shareIcon from "../assets/svg/shareIcon.svg";
import { toast } from "react-toastify";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";

//SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

function Listing() {
  const [listing, setListing] = useState([]);
  const [loading, setLoading] = useState(true);
  const [shareLinkCopied, setShareLinkCopied] = useState(null);
  const navigate = useNavigate();
  const params = useParams();
  const auth = getAuth();
  useEffect(() => {
    const fetchListing = async () => {
      const docRef = doc(db, "listings", params.listingId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setListing(docSnap.data());
        setLoading(false);
      }
    };

    fetchListing();
  }, [navigate, params.listingId]);

  return (
    <main>
      {loading ? (
        <Spinner />
      ) : (
        <Swiper
          modules={[Pagination, Scrollbar, A11y]}
          slidesPerView={1}
          pagination={{ clickable: true }}
        >
          {listing.imgUrls.map((url, index) => (
            <SwiperSlide key={index}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  overflow: "hidden",
                  position: "relative",
                  width: "100%",
                  height: "400px",
                }}
              >
                <img src={listing.imgUrls[index]}></img>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
      <div
        className="shareIconDiv"
        onClick={() => {
          navigator.clipboard.writeText(window.location.href);
          setShareLinkCopied(true);
          toast.success("Link copiato");
        }}
      >
        <img src={shareIcon} />
      </div>
      {loading ? (
        <Spinner />
      ) : (
        <div className="listingDetails">
          <p className="listingName">
            {listing.name} - €{" "}
            {listing.offer
              ? listing.discountedPrice
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : listing.regularPrice
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </p>
          <p className="listingLocation">{listing.location}</p>
          <p className="listingType">
            In {listing.type === "rent" ? "Affitto" : "Vendita"}
          </p>
          <p className="discountPrice">In Offerta</p>
          <ul className="listingDetailsList">
            <li>
              {listing.bedrooms > 1 ? `${listing.bedrooms} letti` : "1 letto"}
            </li>
            <li>
              {listing.bathrooms > 1 ? `${listing.bathrooms} bagni` : "1 bagno"}
            </li>
            <li>{listing.parking && "Parcheggio incluso"}</li>
            <li>{listing.furnished && "Arredato"}</li>
          </ul>
          <p className="listingLocationTitle">Posizione</p>

          <div className="leafletContainer">
            <MapContainer
              style={{ height: "100%", width: "100%" }}
              center={[listing.geolocation.lat, listing.geolocation.lng]}
              zoom={13}
              scrollWheelZoom={false}
            >
              <TileLayer
                attribution="© OpenStreetMap"
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker
                position={[listing.geolocation.lat, listing.geolocation.lng]}
              >
                <Popup>{listing.location}</Popup>
              </Marker>
            </MapContainer>
          </div>
          {auth.currentUser?.uid !== listing.userRef && (
            <Link
              to={`/contact/${listing.userRef}?listingName=${listing.name}`}
              className="primaryButton"
            >
              Contatta il proprietario
            </Link>
          )}
        </div>
      )}
      <br />
      <br />
      <br />
      <br />
    </main>
  );
}

export default Listing;
